import Vue from "vue";

Vue.component("wto-on-behalf-of", {
	props: ["label",
		"labelGroupMembers",
		"language",
		"countryGroup",
		"ids",
		"isReadonly"
	],
	data() {
		return {
			loadingText: window.labels.loading,
			noItemFound: htmlEntity.decode(window.labels.noItemFound),
			loading: false,
			userHasCountryGroup: false,
			userCountryGroups: [],
			userAllGroupCountries: [],
			filteredGroupCountries: [],
			distinctGroupCountries: [],
			countryGroupNames: [],
			isOnBehalfOfAllGroup: false,
			countryGroupId: this.countryGroup,
		};
	},
	methods: {
		getUserCountryGroups: function () {
			this.loading = true;
			this.$services.countryGroups.getForDropdown({ language: this.language })
				.then((data) => {
					this.userCountryGroups = data.items;
					this.userAllGroupCountries = data.groupItems;

					this.getDistinctGroupCountry(data.groupItems);

					if (this.ids.length > 0) {
						this.ids.forEach(id => {
							this.countryGroupNames.push(data.groupItems.filter(item => item.value == id)[0]);
						});
					}

					this.loading = false;
				});
		},
		getFilteredItems(text) {
			var countryGroup = this.userAllGroupCountries;
			if (!this.countryGroupId) {
				countryGroup = this.distinctGroupCountries;
			}

			this.filteredGroupCountries = countryGroup.filter((option) => {
				return option
					.text
					.toLowerCase()
					.indexOf(text.toLowerCase()) >=
					0;
			})
		},
		getGroupCountry: function (groupId) {
			let listGroupCountries = this.userAllGroupCountries;
			let returnValue = [];
			this.isOnBehalfOfAllGroup = false;

			if (groupId) {
				this.isOnBehalfOfAllGroup = true;

				returnValue = listGroupCountries.filter(function (item) {
					return item.groupId == groupId;
				})
			}

			this.countryGroupNames = returnValue;
		},
		getDistinctGroupCountry: function (countryGroups) {
			var result = [];

			countryGroups.forEach(function (item) {
				if (result.filter(i => i.value == item.value).length == 0) {
					result.push(item);
				};
			})

			this.distinctGroupCountries = result;
		},
		getText: function (value) {
			let dataSource = this.userCountryGroups;
			if (dataSource && value) {
				var item = dataSource.filter(item => item.value === value)[0];
				if (item) {
					return item.text;
				}
			}
			return '';
		},
		getDataSourceMultiText: (dataSource, value) => {
			if (dataSource) {
				const items = dataSource.filter(i => value.includes(i.value));
				var returnValue = "";
				items.forEach(function (item) {
					returnValue += `${item.text}; `;
				});
				return returnValue;
			}
			return "";
		},
		changeCountryGroupId: function () {
			this.getGroupCountry(this.countryGroupId);
			this.changeCountryGroupNames();
			this.$emit("update:countryGroup", this.countryGroupId);
		},
		changeCountryGroupNames: function () {
			let tempValue = [];
			this.countryGroupNames.forEach(item => {
				tempValue.push(item.value);
			});
			this.$emit("update:ids", tempValue);
		}
	},
	mounted: function () {
		this.getUserCountryGroups();
		if (this.countryGroupId && this.countryGroupId.length > 0) {
			this.isOnBehalfOfAllGroup = true;
		}
	},
	template: `
		<b-field :label="label">
			<div v-if="loading">
				<loading :loading-text="loadingText"></loading>
			</div>
			<div v-else>
				<div class="columns">
					<div class="column">
						<b-select v-if="!isReadonly" v-model="countryGroupId" @input="changeCountryGroupId" expanded>
							<option v-for="option in userCountryGroups"
									:value="option.value"
									:key="option.value">
								{{ option.text }}
							</option>
						</b-select>
						<div v-else class="input">{{ getText(countryGroupId) }}</div>
					</div>
				</div>

				<div class="columns">
					<div class="column">
						<b-field :label="labelGroupMembers">
							<b-taginput v-if="!isReadonly" v-model="countryGroupNames" @input="changeCountryGroupNames"
										:data="filteredGroupCountries"
										autocomplete
										ref="taginput"
										icon="label"
										field="text"
										:allow-new="false"
										:disabled="isOnBehalfOfAllGroup"
										@typing="getFilteredItems">
								<template slot-scope="props">
									{{props.option.text}}
								</template>
								<template #empty>
									{{ noItemFound }}
								</template>
							</b-taginput>
							<div v-if="isReadonly" class="textarea wto-textarea-editor-readonly" style="min-height: 60px !important">{{ getDataSourceMultiText(distinctGroupCountries, ids) }}</div>
						</b-field>
					</div>
				</div>
			</div>		
		</b-field>		
	`
});